<template>
  <li class="col-12 col-sm-6 col-xl-12 filter-group">
    <div :class="{'active':$parent.activeGroup === filterGroup.id}">
      <div class="title d-flex justify-content-between align-items-center"
           @click="$parent.toggleFilterGroup(filterGroup.id)">
        <span>{{ filterGroup.name }} <span v-if="activeChildrenFilters > 0">({{ activeChildrenFilters }})</span></span>
        <span class="icon-caret"></span>
      </div>
      <ul class="unstyled">
        <filter-element v-for="filterElement in filterGroup.children"
                        :filterElement="filterElement"
                        :key="filterElement.id"
                        :is-active="$parent.activeFilters.includes(filterElement.id)"
                        @statusChange="$parent.filterChange"/>
      </ul>
    </div>
  </li>
</template>
<script>
import FilterElement from "./FilterElement";

export default {
  name: 'filter-group',
  props: {
    filterGroup: Object
  },
  computed: {
    activeChildrenFilters() {
      return this.filterGroup.children.filter(filterElement => this.$parent.activeFilters.includes(filterElement.id)).length;
    },
  },
  components: {FilterElement}
}
</script>
